export default "__VITE_ASSET__a03a5a7c__"